import axios from "axios";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { X, Send } from "lucide-react";
import swl from "sweetalert2";
import JobStatusModal from "./JobStatusModal";
import { promises } from "dns";
function SendSmsFarmer() {
  const [selectedFarmers, setSelectedFarmers] = useState<any[]>([]);
  const [farmersList, setFarmersList] = useState<any[]>([]);
  const [searchInput, setSearchInput] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checked, setchecked] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [codePatern, setCodePatern] = useState<any>(null);
  const [showModalDetal, setShowModaldatal] = useState<any>(false);
  const [DataResponeDetal, setDataResponeDetal] = useState<any>(true);
  const [loadingModal, setloadingModal] = useState<any>(false);
  const cropyearID = Number(localStorage.getItem("crop_year_id"));

  const handlercheck = () => {
    setchecked(!checked);
  };
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropyearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  const fetchFarmers = async () => {
    setIsLoading(true);
    try {
      let url = `https://api.havirkesht.ir/commitment/?crop_year_id=${cropyearID}&sort_by=updated_at&sort_order=desc`;
      if (searchInput) {
        url += `&search=${encodeURIComponent(searchInput)}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      setFarmersList(response.data?.items || []);
    } catch (error: any) {
      console.error("Error fetching farmers data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sendSelectedFarmers = async () => {
    setIsSending(true);
    try {
      if (!codePatern) {
        return swl.fire("خطا", "لطفا کد پترن وارد کنید", "error");
      }

      if (checked === true) {
        try {
          const response = await axios.post(
            "https://api.havirkesht.ir/sms/bulk-farmer-sms-async",
            {
              farmer_ids: [0],
              pattern_code: codePatern,
              // farmer_ids: farmerIds,
              send_to_all: true,
              interval_seconds: 0.3,
              crop_year_id: Number(localStorage.getItem("crop_year_id")),
              max_retries: 3,
              retry_delay: 1,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );
          const JobID = response.data.job_id;
          if (response.status === 200) {
            await swl.fire({
              title: "ارسال پیام",
              text: "پیام‌ برای همه کشاورزان با موفقیت ارسال شد و تا دقایقی دیگر نتیجه اعلام خواهد شد !",
              icon: "success",
            });
            await new Promise((resolve) => setTimeout(resolve, 4000));
            const status = await axios.get(
              `https://api.havirkesht.ir/sms/bulk-job-status/${JobID}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
                },
              }
            );
            setDataResponeDetal(status?.data);
            setShowModaldatal(true);
          }
        } catch (error) {
          console.log("sen sms for all farmer filding error", error);
        }
      } else {
        if (selectedFarmers.length === 0) return;
        const farmerIds = selectedFarmers.map((f) => f.value);
        if (farmerIds.length <= 50) {
          const response = await axios.post(
            "https://api.havirkesht.ir/sms/bulk-farmer-sms",
            {
              pattern_code: codePatern,
              farmer_ids: farmerIds,
              interval_seconds: 0.3,
              max_retries: 3,
              retry_delay: 1,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );

          if (response.status === 200) {
            swl.fire({
              title: "ارسال پیام",
              text: "پیام‌ با موفقیت ارسال شدند!",
              icon: "success",
            });
            setCodePatern("");
            setSelectedFarmers([]);
          }
        } else {
          // Handle case when farmerIds.length > 50
          // You should add appropriate logic here
        }
      }
    } catch (error) {
      console.error("Error sending SMS:", error);
      swl.fire({
        title: "ارسال پیام",
        text: "خطا در ارسال پیام‌ها!",
        icon: "error",
      });
    } finally {
      setIsSending(false);
    }
  };
  const toggleSelectAll = () => {};

  const handlerRefresh = async (jobId: any) => {
    setloadingModal(true);
    const status = await axios.get(
      `https://api.havirkesht.ir/sms/bulk-job-status/${jobId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      }
    );
    setDataResponeDetal(status?.data);
    setloadingModal(false);
    setShowModaldatal(true);
  };

  useEffect(() => {
    fetchFarmers();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput) {
        fetchFarmers();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    // Update selectAll state when selectedFarmers changes
    if (
      selectedFarmers.length === farmersList.length &&
      farmersList.length > 0
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedFarmers, farmersList]);

  const removeFarmer = (farmerId: string) => {
    setSelectedFarmers(selectedFarmers.filter((f) => f.value !== farmerId));
  };

  return (
    <div className="min-h-screen   p-6">
      <div className="max-w-6xl mx-auto dark:bg-gray-800 rounded-xl overflow-hidden p-6">
        <h1 className="text-xl font-bold text-gray-800 mb-6">
          ارسال پیام به کشاورزان
        </h1>
        <div className="mb-8 ">
          <label className="block text-md font-medium text-gray-700 mb-3">
            {selectedFarmers.length > 0 ? (
              <span className="text-green-600">
                کشاورزان انتخاب شده ({selectedFarmers.length} نفر)
              </span>
            ) : (
              <span className="text-red-600 ">
                لطفا کشاورز(ها) را انتخاب کنید:
              </span>
            )}
          </label>
          <span>سال زراعی انتخاب شده {YearCoptSelect}</span>
          <div className="flex items-center justify-end mt-2 mb-4">
            {codePatern ? (
              <X
                onClick={() => setCodePatern("")}
                className="cursor-pointer text-red-600"
              />
            ) : (
              ""
            )}
            <input
              value={codePatern}
              onChange={(e) => setCodePatern(e.target.value)}
              type="text"
              className="border border-gray-300 mx-2 p-1 rounded-md"
              placeholder="کد پترن"
            />

            <button
              onClick={sendSelectedFarmers}
              disabled={isSending}
              className={`flex items-center px-6 py-2 rounded-lg text-white font-medium transition-all
                    ${
                      isSending
                        ? "bg-blue-400"
                        : "bg-blue-600 hover:bg-blue-700 shadow-md"
                    }
                  `}
            >
              {isSending ? (
                <span>در حال ارسال...</span>
              ) : (
                <>
                  <Send className="ml-2 h-4 w-4" />
                  <span>ارسال </span>
                </>
              )}
            </button>
          </div>
          <div className="flex flex-col w-24  py-3 justify-startitems-center">
            <div className="">
              <input
                className="px-2 py-2"
                type="checkbox"
                onClick={handlercheck}
              />
              <span className="text-gray-700 px-2 text-md dark:text-gray-100">
                انتخاب همه
              </span>
            </div>
            {checked && (
              <button
                onClick={sendSelectedFarmers}
                disabled={isSending}
                className={`flex items-center px-6 py-2 rounded-lg text-white font-medium transition-all
                    ${
                      isSending
                        ? "bg-blue-400"
                        : "bg-blue-600 hover:bg-blue-700 shadow-md"
                    }
                  `}
              >
                {isSending ? (
                  <span>در حال ارسال...</span>
                ) : (
                  <>
                    <Send className="ml-2 h-4 w-4" />
                    <span>ارسال </span>
                  </>
                )}
              </button>
            )}
          </div>
          <div className="relative">
            <Select
              options={farmersList
                .filter(
                  (farmer) =>
                    !selectedFarmers.some((sf) => sf.value === farmer.id)
                )
                .map((farmer) => ({
                  value: farmer.farmer_id || `کشاورز (${farmer.id})`,
                  label: farmer.farmer_name,
                }))}
              value={null}
              onChange={(selectedOption: any) => {
                if (selectedOption) {
                  setSelectedFarmers([...selectedFarmers, selectedOption]);
                  setSearchInput("");
                }
              }}
              onInputChange={(inputValue) => {
                setSearchInput(inputValue);
              }}
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: "50px",
                  borderColor: state.isFocused ? "#4CAF50" : "#ddd",
                  boxShadow: state.isFocused ? "0 0 0 1px #4CAF50" : "none",
                  "&:hover": {
                    borderColor: state.isFocused ? "#4CAF50" : "#ccc",
                  },
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              placeholder="نام کشاورز را جستجو و انتخاب کنید..."
              noOptionsMessage={() => "کشاورزی با این مشخصات یافت نشد"}
              loadingMessage={() => "در حال بارگذاری..."}
              className="w-full text-lg"
              classNamePrefix="select"
              maxMenuHeight={300}
              isSearchable
              isLoading={isLoading}
              closeMenuOnSelect={true}
            />
          </div>
        </div>

        {selectedFarmers.length > 0 && (
          <div className="mb-8">
            <div className="bg-gray-50 dark:bg-gray-600 dark:text-gray-50 rounded-lg border border-gray-200 p-4">
              <div className="flex flex-wrap gap-3 mb-4">
                {selectedFarmers.map((farmer) => (
                  <div
                    key={farmer.value}
                    className="flex items-center bg-green-100 text-green-800 px-4 py-2 rounded-full shadow-sm"
                  >
                    <span className="font-medium">{farmer.label}</span>
                    <button
                      onClick={() => removeFarmer(farmer.value)}
                      className="mr-2 text-red-500 hover:text-red-700 transition-colors"
                    >
                      <X className="h-5 w-5" />
                    </button>
                  </div>
                ))}
              </div>

              <div className="text-right dark:text-gray-50 text-gray-600">
                تعداد انتخاب شده:{" "}
                <span className="font-bold">{selectedFarmers.length}</span> نفر
              </div>
            </div>
          </div>
        )}
      </div>
      {showModalDetal && (
        <JobStatusModal
          data={DataResponeDetal}
          onClose={() => setShowModaldatal(false)}
          loadingModal={loadingModal}
          onRefresh={(data) => handlerRefresh(data)}
        />
      )}
    </div>
  );
}

export default SendSmsFarmer;
